import { render, staticRenderFns } from "./edit-prize-activity.vue?vue&type=template&id=0137aeb6&scoped=true&"
import script from "./edit-prize-activity.vue?vue&type=script&lang=js&"
export * from "./edit-prize-activity.vue?vue&type=script&lang=js&"
import style0 from "./edit-prize-activity.vue?vue&type=style&index=0&id=0137aeb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137aeb6",
  null
  
)

export default component.exports